// Borrador persistente del paso 2 del alta de orden (localStorage): sobrevive a un refresco, al cierre
// del navegador o de la PWA. Se guarda por usuario y por origen (nueva o copia) e incluye el cliente
// elegido en el paso 1.
import { EMPTY_ORDER_FORM, type OrderFormValues } from '../domain/orderForm.ts';

const PREFIX = 'servicioos:order-draft:';

const key = (userId: string, sourceOrderId: string | null) => `${PREFIX}${userId}:${sourceOrderId ?? 'new'}`;

export interface OrderDraft {
  clientId: string | null;
  values: OrderFormValues;
}

export function loadOrderDraft(userId: string, sourceOrderId: string | null): OrderDraft | null {
  try {
    const raw = localStorage.getItem(key(userId, sourceOrderId));
    if (!raw) return null;
    const data: unknown = JSON.parse(raw);
    if (typeof data !== 'object' || data === null) return null;
    const stored = data as { clientId?: unknown; values?: unknown };
    // Borradores anteriores a la separación del cliente guardaban los valores sin envoltorio.
    const source = (typeof stored.values === 'object' && stored.values !== null ? stored.values : data) as Record<
      string,
      unknown
    >;
    const values = { ...EMPTY_ORDER_FORM };
    for (const field of Object.keys(EMPTY_ORDER_FORM) as (keyof OrderFormValues)[]) {
      const value = source[field];
      // Solo valores del mismo tipo que el formulario vacío (texto o sí/no); el resto queda vacío.
      if (typeof value === typeof EMPTY_ORDER_FORM[field]) (values as Record<string, unknown>)[field] = value;
    }
    return { clientId: typeof stored.clientId === 'string' ? stored.clientId : null, values };
  } catch {
    return null;
  }
}

export function saveOrderDraft(userId: string, sourceOrderId: string | null, draft: OrderDraft): void {
  try {
    localStorage.setItem(key(userId, sourceOrderId), JSON.stringify(draft));
  } catch {
    // Sin almacenamiento disponible: el formulario sigue funcionando sin borrador.
  }
}

export function clearOrderDraft(userId: string, sourceOrderId: string | null): void {
  try {
    localStorage.removeItem(key(userId, sourceOrderId));
  } catch {
    // Nada que borrar.
  }
}

/** Borra todos los borradores del dispositivo (al cerrar sesión). */
export function clearAllOrderDrafts(): void {
  try {
    for (const name of Object.keys(localStorage)) if (name.startsWith(PREFIX)) localStorage.removeItem(name);
  } catch {
    // Nada que borrar.
  }
}
